import React, { useState, useEffect, useLayoutEffect, useRef } from "react";
import { Spin, message, Modal } from "antd";
// import AmCharts from "@amcharts/amcharts3-react";
import { LoadingOutlined } from "@ant-design/icons";
import * as am4core from "@amcharts/amcharts4/core";
import * as am4charts from "@amcharts/amcharts4/charts";
// import * as am4plugins_sunburst from "@amcharts/amcharts4/plugins/sunburst";
import am4themes_animated from "@amcharts/amcharts4/themes/animated";
import EventEditModal from "./EventEditModal";

am4core.useTheme(am4themes_animated);

const SemiCirclePieChart = (props) => {
  const antIcon = <LoadingOutlined style={{ fontSize: 80 }} spin />;
  const chartRef = useRef(null);
  const [stateData, setStateData] = useState({
    visible: false,
    selectedSliceData: null,
  });

  const info = () => {
    Modal.info({
      title: "This is a notification message",
      content: (
        <div>
          <p>some messages...some messages...</p>
          <p>some messages...some messages...</p>
        </div>
      ),
      onOk() {},
    });
  };

  useEffect(() => {
    
    let chart = am4core.create(
      props.divId ? props.divId : "DivID",
      am4charts.PieChart
    );

    chart.hiddenState.properties.opacity = 0; // this creates initial fade-in
    // chart.paddingRight = 30;
    // chart.dateFormatter.inputDateFormat = "yyyy/MM/dd";

    chart.data = props.data;
    chart.radius =
      props.config && props.config.chart && props.config.chart.radius
        ? am4core.percent(props.config.chart.radius)
        : am4core.percent(70);
    chart.innerRadius =
      props.config && props.config.chart && props.config.chart.innerRadius
        ? am4core.percent(props.config.chart.innerRadius)
        : am4core.percent(40);
    chart.startAngle =
      props.config && props.config.chart && props.config.chart.startAngle
        ? props.config.chart.startAngle
        : 180;
    chart.endAngle =
      props.config && props.config.chart && props.config.chart.endAngle
        ? props.config.chart.endAngle
        : 360;

    let series = chart.series.push(new am4charts.PieSeries());
    series.dataFields.value =
      props.config && props.config.series && props.config.series.value
        ? props.config.series.value
        : "val";
    series.dataFields.category =
      props.config && props.config.series && props.config.series.category
        ? props.config.series.category
        : "cat";

    series.slices.template.cornerRadius =
      props.config && props.config.series && props.config.series.cornerRadius
        ? props.config.series.cornerRadius
        : 10;
    series.slices.template.innerCornerRadius =
      props.config &&
      props.config.series &&
      props.config.series.innerCornerRadius
        ? props.config.series.innerCornerRadius
        : 7;
    series.slices.template.draggable =
      props.config && props.config.series && props.config.series.draggable
        ? props.config.series.draggable
        : true;
    series.slices.template.inert =
      props.config && props.config.series && props.config.series.inert
        ? props.config.series.inert
        : true;
    // series.slices.template.stroke = am4core.color("#fff");
    series.alignLabels =
      props.config && props.config.series && props.config.series.alignLabels
        ? props.config.series.alignLabels
        : false;

    series.hiddenState.properties.startAngle =
      props.config && props.config.series && props.config.series.startAngle
        ? props.config.series.startAngle
        : 90;
    series.hiddenState.properties.endAngle =
      props.config && props.config.series && props.config.series.endAngle
        ? props.config.series.endAngle
        : 90;
    series.labels.template.maxWidth = 90;
    series.labels.template.wrap = true;
    series.labels.template.fill = am4core.color("#7f7f7f");
    series.slices.template.events.on(
      "hit",
      function (ev) {
        
      },
      this
    );

    chart.legend = new am4charts.Legend();
    return () => {
      chart.dispose();
    };
  }, [props]);

  const modelCloseHandler = (needRefetch) => {
    setStateData({ visible: false, selectedEventData: null });
    if (needRefetch) {
      props.refatchData();
    }
  };

  return (
    <div>
      {/* <div id={(props.divId) ? props.divId : "DivID"} style={{ width: "100%", height: "330px" }}></div> */}
      <div
        id={props.divId ? props.divId : "DivID"}
        style={{
          width:
            props.config && props.config.width ? props.config.width : "100%",
          height:
            props.config && props.config.height ? props.config.height : "400px",
        }}
      ></div>
      <Modal
        title="popupmodal"
        centered
        open={stateData.visible}
        onOk={() => setStateData({ visible: false, selectedSliceData: null })}
        onCancel={() =>
          setStateData({ visible: false, selectedSliceData: null })
        }
      ></Modal>
    </div>
  );
};

export default SemiCirclePieChart;
